import React from "react";

interface MetricsBoxProps {
    label: string;
    value: number;
    sublabel: string;
}

const MetricsBox: React.FC<MetricsBoxProps> = ({ label, value, sublabel }) => {
    return (
        <div className="metrics-box">
            <div className="metrics-box__label">{label}</div>
            <div className="metrics-box__value">{value}</div>
            <div className="metrics-box__sublabel">{sublabel}</div>
            <hr className="metrics-box__divider" />
        </div>
    );
};

export default MetricsBox;

